/*
 * @Copyright 2020. Institute for Future Intelligence, Inc.
 * @author Charles Xie
 */

import {Person} from "./Person";

export class User implements Person {

  public fullName: string;
  public displayName: string;
  public email: string;
  public photoURL: string;
  public uid: string;

  constructor(public firstName: string, public middleInitial: string, public lastName: string) {
    if (middleInitial) {
      this.fullName = firstName + " " + middleInitial + " " + lastName;
    } else {
      this.fullName = firstName + " " + lastName;
    }
  }

  nullify(): void {
    this.fullName = undefined;
    this.displayName = undefined;
    this.email = undefined;
    this.photoURL = undefined;
    this.uid = undefined;
  }

}
